import { render, staticRenderFns } from "./gamePlayTypeConfig.vue?vue&type=template&id=66ce792a&"
import script from "./gamePlayTypeConfig.vue?vue&type=script&lang=js&"
export * from "./gamePlayTypeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ce792a')) {
      api.createRecord('66ce792a', component.options)
    } else {
      api.reload('66ce792a', component.options)
    }
    module.hot.accept("./gamePlayTypeConfig.vue?vue&type=template&id=66ce792a&", function () {
      api.rerender('66ce792a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameManager/gamePlayTypeConfig.vue"
export default component.exports